import React from 'react';
import styled from '@emotion/styled';

/**
 * SpreadBar — how the room answered one question, with the person's own
 * answer marked. One row per option: label, a bar for the share, the count.
 * Draws the Kysely's results at the door and the change meter's before/after;
 * it never knows who answered what beyond "you".
 */
const Wrap = styled.div`display: flex; flex-direction: column; gap: 0.45rem;`;
const Title = styled.div`font-weight: 600; color: #e8e8ef; line-height: 1.4; margin-bottom: 0.15rem;`;
const Row = styled.div`
  display: grid; grid-template-columns: minmax(0, 1fr) 96px 52px; gap: 0.7rem; align-items: center; font-size: 0.9rem; color: #c9cbd6;
  .label { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .own { color: #8ec1f0; font-weight: 600; }
  .bar { height: 8px; border-radius: 4px; background: #232a36; overflow: hidden; } .bar i { display: block; height: 100%; background: ${(p) => p.$c}; }
  .n { text-align: right; font-variant-numeric: tabular-nums; color: #9aa4b2; white-space: nowrap; }
`;
const Foot = styled.div`font-size: 0.78rem; color: #7b8794; margin-top: 0.2rem;`;

/**
 * @param {{ id: string, text: string, count: number, color?: string }[]} options
 * @param {number} total  how many answered this question
 * @param {string[]} own  the option ids this person chose
 */
export default function SpreadBar({ title = null, options = [], total = 0, own = [], footer = null, color = '#8ec1f0' }) {
  const mine = new Set(own);
  return (
    <Wrap>
      {title && <Title>{title}</Title>}
      {options.map((o) => (
        <Row key={o.id} $c={o.color || color} title={o.text}>
          <span className={`label${mine.has(o.id) ? ' own' : ''}`}>{mine.has(o.id) ? '▸ ' : ''}{o.text}</span>
          <span className="bar"><i style={{ width: `${total ? Math.round((o.count / total) * 100) : 0}%` }} /></span>
          <span className="n">{total ? `${Math.round((o.count / total) * 100)} %` : '–'}</span>
        </Row>
      ))}
      {footer && <Foot>{footer}</Foot>}
    </Wrap>
  );
}
